import { ProminenceGroupApiModel } from './prominence-group-api.model';

export class ProminenceGroupModel implements ProminenceGroupApiModel {
    id?: number;
    name?: string;
    keywords?: string[];
    editing?: boolean;
    nameExists?: boolean;
    emptyName?: boolean;
    emptyKeywords?: boolean;
    tempUuid?: string;

    constructor(apiModel?: ProminenceGroupApiModel) {
        if (apiModel) {
            this.id = apiModel.id;
            this.name = apiModel.name;
            this.keywords = apiModel.keywords.map(x => x);
        }
    }

    setApiModel(): ProminenceGroupModel {
        return new ProminenceGroupModel({
            id: this.id,
            name: this.name,
            keywords: this.keywords
        });
    }

    /**
     * Compares names and keywords only
     * @param group model to compare against
     * @returns true if a match, false otherwise
     */
    compare(group: ProminenceGroupModel): boolean {
        if (this.name.trim() !== group.name.trim() || JSON.stringify(this.keywords) !== JSON.stringify(group.keywords)) {
            return false;
        } else {
            return true;
        }
    }
}
